/* eslint-disable func-style */
/* eslint-disable no-param-reassign */

import React from 'react';
import ReactDOM from 'react-dom';
import mobilePublicComponent from 'component/mobile/index-share';
import mobilePublicComponentWithShare from 'component/mobile/index';
import { setFingerprintAndUpdateReportParam } from '@util/fingerprint';
import { interactionReport } from '@util/interactionReport';
import initSentry from '@/util2/sentry';

/* eslint-disable consistent-return */
/**
 * 挂载组件的方法
 * @param {object} Entry 挂载的 dom
 * @param {object} option 配置对象。包含的属性: isMobile 移动端配置，用来嵌套移动端的适配；wxShare：开启移动端的微信分享功能
 */
function bootstrap(Entry, option) {
  if (!!option && option.isMobile) {
    Entry = option.wxShare ? mobilePublicComponentWithShare(Entry) : mobilePublicComponent(Entry);
  }

  // eslint-disable-next-line no-undef
  if (EASY_ENV_IS_BROWSER) {
    const root = document.getElementById('app');
    const renderMethod = root.childNodes.length > 0 ? 'hydrate' : 'render';
    const state = window.__INITIAL_STATE__;

    ReactDOM[renderMethod](<Entry {...state} />, root);
    // eslint-disable-next-line no-undef
    if (EASY_ENV_IS_DEV) {
      module.hot.accept(() => {
        ReactDOM[renderMethod](<Entry {...state} />, root);
      });
    }
    initSentry();
    setFingerprintAndUpdateReportParam();
    interactionReport();
    return;
  }
  return Entry;
}

export { bootstrap };

export default {};
